module.exports = __webpack_public_path__ + "img/deportivas.91dd8bbf.jpg";